import { render, staticRenderFns } from "./editAssignBusRouteStudent.vue?vue&type=template&id=4e2411a9"
import script from "./editAssignBusRouteStudent.vue?vue&type=script&lang=js"
export * from "./editAssignBusRouteStudent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports